import React, { useState, useEffect, useCallback, useRef, useMemo } from "react"
import { useParams, useHistory } from 'react-router-dom'
import { useLocation } from "react-router"

import AuthorizedFunction from '@security/AuthorizedFunction'

import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/Search'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import { ButtonPrimary } from '@base/Button/Button'
import AddIcon from '@material-ui/icons/Add'
import CircularProgress from '@material-ui/core/CircularProgress'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutline'
import SelectOption from "@base/Inputs/Select"
import Boolean from "@base/Inputs/Boolean"
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import Filters from '@base/Filter'
import TextField from '@base/Inputs/Text'
import DialogConfirm from '@base/Dialog/DialogConfirm'
import AssignmentLateIcon from '@material-ui/icons/AssignmentLate';
import { ButtonExport } from '@base/Button/ButtonExport'

import InformacoesEscolaDialog from '@pages/Escola/InformacoesEscolaDialog'
import InvalidarEscolaDialog from '@pages/Escola/InvalidarEscolaDialog'
import ImprimirSegundaViaDialog from '@pages/Escola/ImprimirSegundaViaDialog'
import ConsiderarNotaProfessorDialog from '@pages/Escola/ConsiderarNotaProfessorDialog'

import {
  verifyPagingAndSorting,
  PAGE,
  SIZE,
  ASC,
  TOTAL_ELEMENTS,
  TOTAL_PAGES,
} from '@base/Table/Utils'

import EscolaService from "@services/EscolaService"

import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'
import {
  optionsMaterialEnum,
  optionsPendenciasAbertasEnum,
  optionsStatusEscolaEnum,
} from "@helpers/EnumHelper"

import { download } from '@helpers/FileHelper';

import useCaixas from "@hooks/enums/useCaixas";
import useUfs from "@hooks/enums/useUfs";
import useRegioes from "@hooks/enums/useRegioes";
import useDECriterios from "@hooks/enums/useDECriterios"

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

export const ListagemEscolas = () => {
  const params = useParams();
  let processo = ProcessoResolver(params.processo);

  const [loading, setLoading] = useState(true);

  const [list, setList] = useState([]);
  const [listagemMunicipio, setListagemMunicipio] = useState([]);

  const listagemCaixas = useCaixas(processo.id);
  const listagemUF = useUfs(processo.id);
  const listagemRegioes = useRegioes(processo.id);
  const listagemDECriterios = useDECriterios(processo.id);

  const [page, setPage] = useState(PAGE);
  const [size, setSize] = useState(SIZE);
  const [defaultOrderBy,] = useState('nome')
  const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
  const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
  const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

  const [filtros, setFiltros] = useState([]);
  const [filtroAtivo, setFiltroAtivo] = useState(false);
  const [filtroUF, setFiltroUF] = useState('');
  const [filtroRegiao, setFiltroRegiao] = useState('');
  const [filtroMunicipio, setFiltroMunicipio] = useState('');

  const [filtroStatus, setFiltroStatus] = useState();
  const [filtroPostagem, setFiltroPostagem] = useState();
  const [filtroInep, setFiltroInep] = useState();
  const [filtroNomeEscola, setFiltroNomeEscola] = useState();
  const [filtroEticket, setFiltroEticket] = useState();
  const [filtroCodigoObjetoPostal, setFiltroCodigoObjetoPostal] = useState();
  const [filtroMaterialRecebido, setFiltroMaterialRecebido] = useState('');
  const [filtroPendenciaAbertas, setFiltroPendenciaAbertas] = useState('');
  const [filtroTriagemRealizada, setFiltroTriagemRealizada] = useState('');
  const [filtroCartoesEmNiveisNaoPrevistos, setFiltroCartoesEmNiveisNaoPrevistos] = useState('');

  const [filtroCartoesDigitalizados, setFiltroCartoesDigitalizados] = useState('');
  const [filtroDesDigitalizados, setFiltroDesDigitalizados] = useState('');
  const [filtroCartoesLidosOCRTexto, setFiltroCartoesLidosOCRTexto] = useState('');
  const [filtroCartoesTeleform, setFiltroCartoesTeleform] = useState('');
  const [filtroCartoesDigitados, setFiltroCartoesDigitados] = useState('');
  const [filtroCaixa, setFiltroCaixa] = useState('');
  const [filtroQtdPacote, setFiltroQtdPacote] = useState('');
  const [filtroAlunosAtendimentoEspecial, setFiltroAlunosAtendimentoEspecial] = useState('');
  const [filtroAlunosSabatistas, setFiltroAlunosSabatistas] = useState('');
  const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

  const [openImportarEscolasDialog, setOpenImportarEscolasDialog] = useState(false);
  const [openEditarEscolaDialog, setOpenEditarEscolaDialog] = useState(false);
  const [openImprimirSegundaViaDialog, setOpenImprimirSegundaViaDialog] = useState(false);
  const [openConsiderarNotaProfessorDialog, setOpenConsiderarNotaProfessorDialog] = useState(false);
  const [codigoInepDialog, setCodigoInepDialog] = useState("");

  const [escolaSelecionada, setEscolaSelecionada] = useState("");

  const [openDialogInvalidarEscola, setOpenDialogInvalidarEscola] = useState(false);

  const history = useHistory();
  const query = useQuery();

  const toastRef = useRef(null);
  const filtroRef = useRef(null);

  function redirecionarParaPaginaDaEscola(codigoInep) {
    history.push("/" + params.processo + "/escola/" + codigoInep);
  }

  function redirecionarParaPaginaDeCartoes(codigoInep) {
    history.push("/" + params.processo + "/escola/" + codigoInep + "/cartoes");
  }

  const abrirModalEditarEscola = (id) => {
    setCodigoInepDialog(id);
    setOpenEditarEscolaDialog(true);
  }

  const abrirModalImprimirDocumentos = (id) => {
    setCodigoInepDialog(id);
    setOpenImprimirSegundaViaDialog(true);
  }

  const abrirModalConsiderarNotaProfessor = (id) => {
    setCodigoInepDialog(id);
    setOpenConsiderarNotaProfessorDialog(true);
  }

  const pageName = 'Escolas';

  const abrirModalImportarEscolas = () => { setOpenImportarEscolasDialog(true); }

  const aplicarFiltros = useCallback((ativo = false, exportarPlanilha = false) => {
    let f = [];

    if (filtroNomeEscola) f.push({ field: 'nome', value: filtroNomeEscola });
    if (filtroInep) f.push({ field: 'inep', value: filtroInep });
    if (filtroEticket) f.push({ field: 'eticket', value: filtroEticket });
    if (filtroUF) f.push({ field: 'uf', value: filtroUF });
    if (filtroRegiao) f.push({ field: 'regiao', value: filtroRegiao });
    if (filtroMunicipio) f.push({ field: 'municipio', value: filtroMunicipio });
    if (filtroStatus) f.push({ field: 'status', value: filtroStatus });
    if (filtroPostagem) f.push({ field: 'postagem', value: filtroPostagem });
    if (filtroMaterialRecebido) f.push({ field: 'materialRecebido', value: filtroMaterialRecebido });
    if (filtroPendenciaAbertas) f.push({ field: 'possuiPendenciasAbertas', value: filtroPendenciaAbertas });
    if (filtroTriagemRealizada) f.push({ field: 'possuiTriagemRealizada', value: filtroTriagemRealizada });
    if (filtroCartoesEmNiveisNaoPrevistos) f.push({ field: 'cartoesEmNiveisNaoPrevistos', value: filtroCartoesEmNiveisNaoPrevistos });
    if (filtroCartoesDigitalizados) f.push({ field: 'cartoesDigitalizados', value: filtroCartoesDigitalizados });
    if (filtroDesDigitalizados) f.push({ field: 'desDigitalizados', value: filtroDesDigitalizados });
    if (filtroCartoesLidosOCRTexto) f.push({ field: 'cartoesLidosOCRTexto', value: filtroCartoesLidosOCRTexto });
    if (filtroCartoesTeleform) f.push({ field: 'cartoesTeleform', value: filtroCartoesTeleform });
    if (filtroCartoesDigitados) f.push({ field: 'cartoesDigitados', value: filtroCartoesDigitados });
    if (filtroCodigoObjetoPostal) f.push({ field: 'codigoObjetoPostal', value: filtroCodigoObjetoPostal });
    if (filtroCaixa) f.push({ field: 'caixa', value: filtroCaixa });
    if (filtroAlunosAtendimentoEspecial) f.push({ field: 'possuiAlunosAtendimentoEspecial', value: filtroAlunosAtendimentoEspecial });
    if (filtroAlunosSabatistas) f.push({ field: 'possuiAlunosSabatistas', value: filtroAlunosSabatistas });
    if (filtroQtdPacote !== undefined) f.push({ field: 'objsPostaisReplicados', value: filtroQtdPacote });

    if (exportarPlanilha) {
      f.push({ field: 'exportarPlanilha', value: exportarPlanilha });

      EscolaService.export(processo.id, f)
        .then(res => download(res))
        .finally();
    } else {
      setFiltros(f);
      setFiltroAtivo(ativo);
      setQuantidadeFiltrosAplicados(f.length);
    }
  }, [filtroAlunosAtendimentoEspecial, filtroAlunosSabatistas, filtroCaixa, filtroCartoesDigitados, filtroCartoesDigitalizados, filtroCartoesEmNiveisNaoPrevistos, filtroCartoesLidosOCRTexto, filtroCartoesTeleform, filtroCodigoObjetoPostal, filtroDesDigitalizados, filtroEticket, filtroInep, filtroMaterialRecebido, filtroMunicipio, filtroNomeEscola, filtroPendenciaAbertas, filtroPostagem, filtroQtdPacote, filtroRegiao, filtroStatus, filtroTriagemRealizada, filtroUF, processo.id]);

  const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

  const limparFiltros = () => {
    setSort([{ orderBy: defaultOrderBy, order: ASC }])
    setPage(PAGE);
    setSize(SIZE);

    setFiltros([]);
    setFiltroAtivo(false);
    setFiltroNomeEscola('');
    setFiltroInep('');
    setFiltroStatus('');
    setFiltroPostagem('');
    setFiltroUF('');
    setFiltroRegiao('');
    setFiltroMunicipio('');
    setFiltroEticket('');
    setFiltroMaterialRecebido('');
    setFiltroPendenciaAbertas('');
    setFiltroTriagemRealizada('');
    setFiltroCartoesEmNiveisNaoPrevistos('');
    setFiltroCartoesDigitalizados('');
    setFiltroDesDigitalizados('');
    setFiltroCartoesLidosOCRTexto('');
    setFiltroCartoesTeleform('');
    setFiltroCartoesDigitados('');
    setFiltroCodigoObjetoPostal('');
    setFiltroCaixa('');
    setFiltroAlunosAtendimentoEspecial('');
    setFiltroAlunosSabatistas('');
    setQuantidadeFiltrosAplicados(0);
  }

  const columns = [
    {
      label: 'Codigo', name: 'codigoInep', func: (c, l) => <>
        <span style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => redirecionarParaPaginaDaEscola(c)}>{c}</span>
        <span style={{
          marginLeft: 3,
          padding: 2,
          borderRadius: 4,
          backgroundColor: "#3fb8ba",
          color: "white",
          display: 'inline-block',
          fontSize: 10
        }}><center>{l.dependenciaAdmin.substring(0, 1)}</center></span>
        {l.considerarNotaProfessor &&
          <span style={{
            marginLeft: 3,
            padding: 2,
            borderRadius: 4,
            backgroundColor: "#ba8c0d",
            color: "white",
            display: 'inline-block',
            fontSize: 10
          }}><center>Considera Nota do Professor</center></span>}

      </>, key: true
    },
    { label: 'Nome', name: 'nome', func: (c, l) => <>{c}</>, key: false },
    { label: 'Município', name: 'municipio', func: (c, l) => { return `${l.municipio ? `${l.municipio}  (${l.uf})` : ""}` }, key: false },
    { label: 'Telefone', name: 'telefone', func: null, key: false },
    { label: 'Status', name: 'status', func: null, key: false },
    // { label: 'Dependência Administrativa', name: 'dependenciaAdmin', filter: 'dependeciaAdmin', func: null, key: false },
    { label: 'Modo Recebimento', name: 'modoRecebimento', func: (c, l) => { return l.modoRecebimento; }, key: false, ordering: false },
    { label: 'Pendências Abertas', name: 'pendencia', func: null, key: false, ordering: false }
  ];

  const actions = [
    {
      name: () => "Editar Informações",
      func: abrirModalEditarEscola,
      icon: <EditOutlinedIcon />,
      disabled: () => false,
    },
    {
      name: () => "Imprimir Documentos",
      func: abrirModalImprimirDocumentos,
      icon: <PrintOutlinedIcon />,
      disabled: () => false,
    },
    {
      name: () => "Listar Cartões",
      func: redirecionarParaPaginaDeCartoes,
      icon: <LibraryBooksIcon />,
      disabled: () => false,
    },
    {
      name: (id) => {
        const c = list.find(c => c.codigoInep === id)
        return `${c.considerarNotaProfessor === true ? "Desconsiderar" : "Considerar"} Notas do Professor para a Escola`;
      },
      func: abrirModalConsiderarNotaProfessor,
      icon: <AssignmentLateIcon />,
      color: (id) => {
        const c = list.find(c => c.codigoInep === id)
        return c.considerarNotaProfessor === true ? "secondary" : "primary";
      },
      disabled: () => false,
    },
    {
      name: () => "Visão Geral da Escola",
      func: redirecionarParaPaginaDaEscola,
      icon: <SearchIcon />,
      disabled: () => false,
    },

    {
      name: () => "Invalidar Escola",
      func: (id) => {
        let c = list.find(c => c.codigoInep === id);
        setEscolaSelecionada(c);
        setOpenDialogInvalidarEscola(true);
      },
      icon: <DeleteOutlinedIcon />,
      color: "secondary",
      disabled: () => (!AuthorizedFunction(["__processo.usuario.central"])),
    }

  ]

  const carregarDados = useCallback(() => {
    const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);
    setLoading(true);
    EscolaService.filtrar(processo.id, f).then(resultado => {

      console.log(resultado);


      const { content, number, size, totalElements, totalPages } = resultado.data;
      setList(content);
      setPage(number);
      setSize(size);
      setTotalElements(totalElements);
      setTotalPages(totalPages);
      setLoading(false);
    }).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar Filtros!"));
  }, [filtros, filtroAtivo, page, size, sort, processo.id]);

  const importarDadosEscolas = () => {
    setLoading(true);

    EscolaService.carregar(processo.id).then(resultado => {
      if (resultado.status === 200) {
        setFiltros([...filtros]);
        toastRef.current.show("success", `Total de ${resultado.data ?? "nenhuma"} Escolas carregadas com sucesso!`);
      } else {
        toastRef.current.show("warning", "Não foi possível carregar dados de Escolas!");
      }
    }).catch(error =>
      toastRef.current.show("error", "Ocorreu um Problema ao Carregar Dados de Escolas!")
    ).finally(() => {
      setOpenImportarEscolasDialog(false);
      setLoading(false);
    });
  };

  const handlePage = page => {
    setPage(page);
    setFiltroAtivo(true);
  };
  const handleRowsPerPage = (size, page) => {
    setPage(page);
    setSize(size);
    setFiltroAtivo(true);
  };

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === orderBy)) {
      let newSort = sort.filter(s => s.orderBy !== orderBy);
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === orderBy)), 0, { orderBy: orderBy, order: order })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== orderBy), { orderBy: orderBy, order: order }]);
    }
    setFiltroAtivo(true);
  }
  const handleClearSort = (orderBy) => {
    setFiltroAtivo(true);
    orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }])
  };
  const handleTotalPages = () => totalPages;
  const handleTotalElements = () => totalElements;

  useEffect(() => carregarDados(), [carregarDados]);

  useEffect(() => {

    if (filtroInep && filtroInep.length === 16) {
      aplicarFiltros(true);
      filtroRef.current.closeFilters();
    }

  }, [filtroInep, aplicarFiltros]);

  useEffect(() => {
    const f = [];

    if (query.get("mecCode")) {
      f.push({ field: 'inep', value: query.get("mecCode") });
      setFiltroInep(query.get("mecCode"));

    } else if (query.get("status")) {
      f.push({ field: 'status', value: query.get("status") });
      setFiltroStatus(query.get("status"));

    } else if (query.get("cartoesEmNiveisNaoPrevistos")) {
      f.push({ field: 'cartoesEmNiveisNaoPrevistos', value: query.get("cartoesEmNiveisNaoPrevistos") });
      setFiltroCartoesEmNiveisNaoPrevistos(query.get("cartoesEmNiveisNaoPrevistos"));
    }

    if (f.length > 0) {
      setFiltros(f);
    }
  }, [query])

  const carregaMunicipio = (uf) => {
    EscolaService.buscarMunicipios(processo.id, uf).then(resultado => {

      let muncipios = resultado.data.map(r => {
        return {
          label: r,
          value: r
        }
      });

      setListagemMunicipio(muncipios);

    });
  }

  const carregaMunicipiosRegiao = (uf) => {
    EscolaService.buscarMunicipiosRegiao(processo.id, uf).then(resultado => {

      let muncipios = resultado.data.map(r => {
        return {
          label: r,
          value: r
        }
      });

      setListagemMunicipio(muncipios);

    });
  }

  const handleExportPlan = () => {
    aplicarFiltros(true, true);
    toastRef.current.show(
      "info",
      "A Planilha está sendo gerada para Exportação."
    );
  }

  return (
    <>
      <Toast ref={toastRef} />

      <Title>{pageName}</Title><br />

      <InvalidarEscolaDialog
        id={escolaSelecionada.codigoInep}
        processo={processo.id}
        aberto={openDialogInvalidarEscola}
        aoFechar={() => {
          setOpenDialogInvalidarEscola(false)
        }
        }
        aoSalvar={() => {
          setOpenDialogInvalidarEscola(false);
          carregarDados();
        }} />

      <Filters
        open={true}
        handleFilter={aplicarFiltros}
        handleFilterClear={limparFiltros}
        countFilters={contarFiltrosAplicados}
        ref={filtroRef}>
        <Grid item container spacing={3}>
          <Grid item sm={2} lg={2}>
            <TextField
              autoFocus
              label='INEP ou Código do Cartão'
              value={filtroInep}
              name='filtroInep'
              inputProps={{ maxLength: 16 }}
              onChange={(e) => setFiltroInep(e.target.value.trim())} />
          </Grid>
          <Grid item sm={4} lg={4}>
            <TextField
              label='Nome da Escola'
              value={filtroNomeEscola}
              name='filtroNomeEscola'
              onChange={(e) => setFiltroNomeEscola(e.target.value)} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <TextField
              label='E-ticket'
              value={filtroEticket}
              name='filtroEticket'
              onChange={(e) => setFiltroEticket(e.target.value.trim())} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <TextField
              label='Código Objeto Postal'
              value={filtroCodigoObjetoPostal}
              name='filtroCodigoObjetoPostal'
              onChange={(e) => setFiltroCodigoObjetoPostal(e.target.value.trim())} />
          </Grid>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item sm={1} lg={1}>
            <SelectOption
              label='UF'
              value={filtroUF}
              name='filtroUF'
              onChange={(e) => {
                setFiltroUF(e.target.value);
                setFiltroRegiao('');
                carregaMunicipio(e.target.value);
              }}
              options={listagemUF.data} />
          </Grid>

          <Grid item sm={1} lg={1}>
            <SelectOption
              label='Região'
              value={filtroRegiao}
              name='filtroRegiao'
              onChange={(e) => {
                setFiltroRegiao(e.target.value);
                setFiltroUF('');
                carregaMunicipiosRegiao(e.target.value);
              }}
              options={listagemRegioes.data} />
          </Grid>

          <Grid item sm={2} lg={2}>
            <SelectOption
              label='Municipio'
              value={filtroMunicipio}
              name='filtroMunicipio'
              onChange={(e) => setFiltroMunicipio(e.target.value)}
              options={listagemMunicipio} />
          </Grid>

          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Modo de Recebimento'
              value={filtroMaterialRecebido}
              name='filtroMaterialRecebido'
              onChange={(e) => setFiltroMaterialRecebido(e.target.value)}
              options={optionsMaterialEnum} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Pendências Abertas'
              value={filtroPendenciaAbertas}
              name='filtroPendenciaAbertas'
              onChange={(e) => setFiltroPendenciaAbertas(e.target.value)}
              options={optionsPendenciasAbertasEnum} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Triagem Realizada'
              value={filtroTriagemRealizada}
              name='filtroTriagemRealizada'
              onChange={(e) => setFiltroTriagemRealizada(e.target.value)}
              options={optionsPendenciasAbertasEnum} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Possui Alunos com Atendimento Especial'
              value={filtroAlunosAtendimentoEspecial}
              name='filtroAlunosAtendimentoEspecial'
              onChange={(e) => setFiltroAlunosAtendimentoEspecial(e.target.value)}
              options={listagemDECriterios.data} />
          </Grid>
          <Grid item sm={3} lg={3}>
            <SelectOption
              label='Possui Alunos Sabatistas'
              value={filtroAlunosSabatistas}
              name='filtroAlunosSabatistas'
              onChange={(e) => setFiltroAlunosSabatistas(e.target.value)}
              options={listagemDECriterios.data} />
          </Grid>
        </Grid>
        <Grid item container spacing={3}>

          <Grid item sm={4} lg={4}>
            <SelectOption
              label='Status'
              value={filtroStatus}
              name='filtroStatus'
              onChange={(e) => setFiltroStatus(e.target.value)}
              options={optionsStatusEscolaEnum}
            />
          </Grid>

          <Grid item sm={2} lg={2}>
            <Boolean
              label='Cartões Digitalizados'
              value={filtroCartoesDigitalizados}
              name='filtroCartoesDigitalizados'
              onChange={(e) => setFiltroCartoesDigitalizados(e.target.value)}
            />
          </Grid>
          <Grid item sm={2} lg={2}>
            <Boolean
              label="DEs Digitalizados"
              value={filtroDesDigitalizados}
              name='filtroDesDigitalizados'
              onChange={(e) => setFiltroDesDigitalizados(e.target.value)}
            />
          </Grid>
          <Grid item sm={2} lg={2}>
            <Boolean
              label='Cartões com Leitura de Textos'
              value={filtroCartoesLidosOCRTexto}
              name='filtroCartoesLidosOCRTexto'
              onChange={(e) => setFiltroCartoesLidosOCRTexto(e.target.value)}
            />
          </Grid>
          <Grid item sm={2} lg={2}>
            <Boolean
              label='Cartões com Leitura de Marcações'
              value={filtroCartoesTeleform}
              name='filtroCartoesTeleform'
              onChange={(e) => setFiltroCartoesTeleform(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid item container spacing={3}>
          <Grid item sm={6} lg={1}>
            <SelectOption
              label='Caixa'
              value={filtroCaixa}
              name='filtroCaixa'
              onChange={(e) => setFiltroCaixa(e.target.value)}
              options={listagemCaixas.data}
              disabled={listagemCaixas.data.length === 0}
            />
          </Grid>

          <Grid item sm={6} lg={3}>
            <SelectOption
              label='Objetos Postais Duplicados'
              value={filtroQtdPacote}
              name='filtroQtdPacote'
              onChange={(e) => setFiltroQtdPacote(e.target.value)}
              options={[{ value: true, label: 'Sim' }, { value: false, label: 'Não' }]}
            />
          </Grid>
          <Grid item sm={6} lg={3}>
            <SelectOption
              label='Postagem'
              value={filtroPostagem}
              name='filtroPostagem'
              onChange={(e) => setFiltroPostagem(e.target.value)}
              options={[{ value: "NO_PRAZO", label: 'Dentro do prazo' }, { value: "FORA_PRAZO", label: 'Fora do prazo' }, { value: "NAO_POSTOU", label: 'Sem postagem' }]}
            />
          </Grid>
          <Grid item sm={12} lg={4}>
            <Boolean
              label='Com Cartões Aptos em Níveis com Quantidades Não Previstas'
              value={filtroCartoesEmNiveisNaoPrevistos}
              name='filtroCartoesEmNiveisNaoPrevistos'
              onChange={(e) => setFiltroCartoesEmNiveisNaoPrevistos(e.target.value)}
            />
          </Grid>
        </Grid>
      </Filters>

      <Grid container spacing={3}>
        {(contarFiltrosAplicados() > 3) &&
          <ButtonExport
            title="Exportar Planilha"
            onClick={handleExportPlan}
          />
        }
      </Grid>

      <Table
        columns={columns}
        tableData={list}
        actions={actions}
        page={page}
        handlePage={handlePage}
        handleTotalPages={handleTotalPages}
        handleTotalElements={handleTotalElements}
        rowsPerPage={size}
        handleRowsPerPage={handleRowsPerPage}
        sort={sort}
        handleSort={handleSort}
        handleClearSort={handleClearSort}
        loading={loading}
        rowsPerPageOptions={[3, 5, 10, 25, 50, 100]}
        disableRowWhen={false}
      />

      <Grid container spacing={3} >
        <Grid item xs={12} >
          <ButtonPrimary
            onClick={abrirModalImportarEscolas}
            name="Importar Dados de Escolas"
            startIcon={loading ? <CircularProgress size={16} /> : <AddIcon />}
            disabled={loading} />
        </Grid>
      </Grid>

      <InformacoesEscolaDialog
        handleClose={() => { setCodigoInepDialog(""); setOpenEditarEscolaDialog(false); }}
        open={openEditarEscolaDialog}
        codigoInep={codigoInepDialog}
      />

      <ImprimirSegundaViaDialog
        processo={processo.id}
        escola={codigoInepDialog}
        aberto={openImprimirSegundaViaDialog}
        aoFechar={() => { setOpenImprimirSegundaViaDialog(false); }}
        handleLoading={setLoading}
      />

      {openConsiderarNotaProfessorDialog &&
        <ConsiderarNotaProfessorDialog
          processo={processo.id}
          codigoInep={codigoInepDialog}
          open={openConsiderarNotaProfessorDialog}
          handleClose={() => {
            setCodigoInepDialog("");
            setOpenConsiderarNotaProfessorDialog(false);

            carregarDados();
          }}
        />
      }

      <DialogConfirm
        maxWidth={"sm"}
        text={"Deseja importar Escolas?"}
        close={() => setOpenImportarEscolasDialog(false)}
        open={openImportarEscolasDialog}
        title={"Importante"}
        handleConfirm={importarDadosEscolas}
      />
    </>
  );
}

export default ListagemEscolas;
